module.exports = __webpack_public_path__ + "img/Kyle.dbbc2b97.png";